import { all } from "redux-saga/effects";
import watchGetUserRegistrationService from "./UserRegistration/UserRegistrationSaga";
import watchGetUserNotificationsService from "./Notifications/GetUserNotificationsSaga";
import watchUpdateUserNotificationsService from "./Notifications/UpdateNotification/UpdateNotificationSaga";
import watchUserEnrolledDevicesService from "./UserEnrolledDevices/UserEnrolledDevicesSaga";
import watchUpdateUserEnrolledDevice from "./UserEnrolledDeviceDetails/UpdateUserEnrolledDeviceDetailsSaga";
import watchGetUserAddressService from "./GetUserAddress/getUserAddressSaga";
import watchFetchShippingAddressService from './ManageAddress/FetchAddress/FetchAddressSaga';
import watchUpdateUserAddress from "./UpdateUserAddress/UpdateUserAddressSaga";
import watchGetUserDeviceRegistrationService from "./UserDeviceRegistration/UserDeviceRegistrationSaga";
import watchGetUserRolesService from "./UserRoles/UserRolesSaga";
import watchBOLApiToken from "./BOL/BOLApiTokenSaga";
import watchFetchOrderHistoryLatestService from './OrderHistoryLatest/OrderHistoryLatestSaga'
import watchNativeAppLogs from "./NativeAppLogs/NativeAppLogsSaga";
import watchUserEnrollmentFailedDevicesService from "./UserEnrollmentFailedDevices/UserEnrollmentFailedDevicesSaga";
import watchGetEasyBuyService from "./EasyBuy/EasyBuySaga";
import watchCreateUserSupplyOrderService from "./OrderEarly/CreateUserSupplyOrder/CreateUserSupplyOrderSaga";
import watchGetSupplyOrderStatusService from "./OrderEarly/GetSupplyOrderStatus/GetSupplyOrderStatusSaga";
import watchGetNewPrinterBundleServicePlan from "./HardwareInclusive/GetNewPrinterBundleServicePlanSaga";

export default function* rootSagasRTK() {
    yield all([
       watchGetUserRegistrationService(),
       watchGetUserNotificationsService(),
       watchUpdateUserNotificationsService(),
       watchUserEnrolledDevicesService(),
       watchUpdateUserEnrolledDevice(),
       watchGetUserAddressService(),
       watchFetchShippingAddressService(),
       watchUpdateUserAddress(),
       watchGetUserDeviceRegistrationService(),
       watchGetUserRolesService(),
       watchBOLApiToken(),
       watchFetchOrderHistoryLatestService(),
       watchNativeAppLogs(),
       watchUserEnrollmentFailedDevicesService(),
       watchGetEasyBuyService(),
       watchCreateUserSupplyOrderService(),
       watchGetSupplyOrderStatusService(),
       watchGetNewPrinterBundleServicePlan()
    ])
}